<template>
  <div class="insights">
    <div class="title">
      <svg-icon icon-name="dashboard-insights" :size="20" class="mr-5"></svg-icon>
      <span>{{ $t('clientDashboard.insights') }}</span>
    </div>
    <div class="__content">
      <template v-for="(item, index) in dataList">
        <div :key="index" @click="openLink(item.linkUrl)" class="item">
          <div class="date" :style="{ background: colorList[index % 3] }" v-html="item.date"></div>
          <div class="info">
            <el-tooltip :content="item.name" placement="top" :popper-class="getIfClientDrawerTag ? 'el-tooltip-drawer' : ''">
              <p class="name">{{ item.name }}</p>
            </el-tooltip>
            <p class="desc">{{ item.desc }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SvgIcon from "@/components/svgIcon/index";

import { insightsList } from './data'

export default {
  name: 'MidPolicy',
  components: {
    SvgIcon
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('common', {
      getIfClientDrawerTag: 'getIfClientDrawerTag',
    }),
    dataList() {
      return [...insightsList[this.$i18n.locale]]
    },
    colorList() {
      return ['#00338d', '#1e49e2', '#7213ea']
    },
  },
  methods: {
    openLink(url) {
      window.open(url)
    },
  }
}
</script>

<style scoped>
.insights {
  height: 100%;
  /* padding: 0 var(--spacing) var(--spacing) var(--spacing); */

  --spacing: 15px;
  --title-height: 46PX;
  --item-height: 56PX;
}

.insights .title {
  height: var(--title-height);
  display: flex;
  align-items: center;
  font-weight: 600;

  font-size: 15PX;
}

.insights .__content {
  height: calc(100% - var(--title-height));
  overflow-y: overlay;
}

.insights .__content::-webkit-scrollbar {
  width: 6PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6PX !important;
}

.insights .__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 11PX;
  background-color: transparent !important;
  transition: background-color 0.3s;
}

.insights .__content:hover::-webkit-scrollbar-thumb {
  background-color: hsla(220, 4%, 58%, 0.3) !important;
}

.insights .__content .item {
  display: flex;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  overflow: hidden;
  height: var(--item-height);
}

.insights .__content .item:last-child {
  margin-bottom: 0;
}

.insights .__content .item .date {
  width: 40PX;
  height: 100%;
  flex-shrink: 0;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.insights .__content .item .info {
  width: 100%;
  line-height: 20PX;
  padding: 5px 10px;
}

.insights .__content .item .name {
  font-size: 13PX;
  font-weight: bolder;
  width: calc(100% - 40PX);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
}

.insights .__content .item .desc {
  width: calc(100% - 40PX);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #a09c9c;
  font-size: 11PX;
}
</style>